export var webserviceurl = "https://3dvam.info/api";
